import { isDev } from "./env-variables";
import { SHOPS_DETAIL_MARKETING_PAGE } from "@constants/external-routes";
import { ALL_PRODUCTS, DEFAULT_SHOP_TAB } from "@constants/shops";
import { DEFAULT_CATERGORY_SLUG } from "@constants/templates-listing";
import { BASE_SHOPS_PATH, SHOPS_DASHBOARD_HOSTNAME, HOME_URL } from "@constants/app-defaults";
import { STADIUM_LOCKER_RESTOCK_URL } from "@stadium/common/src/constants/accounts";
import { KIT_DASHBOARD_ROUTE } from "@stadium/constants/kits";
import { MY_WORKSPACE_SLUG } from "@stadium/constants";
import {
  BYSTADIUM_MARKETING_URL,
  LOCKER_DASHBOARD_TAB_URL,
  LOCKER_DASHBOARD_URL,
} from "@stadium/helpers/app-routes";
import { generateUrlByQuery } from "@stadium/helpers/dom";
import { WORKSPACE_SLUG } from "@stadium/constants/routes";
import { users } from "@stadium/shared/constants/routes";

export const MY_WORKSPACE_BASE_PATH = `/${MY_WORKSPACE_SLUG}`;

export const MY_PURCHASES = "purchases";
export const MY_SWAG_ORDERS = "swag-orders";
export const MY_SENT_GIFTS = "sent-gifts";
export const RECIPIENT_PURCHASES = "recipient-purchases";

export const WALLET_ROUTE = "/wallet";

export const CONTACTS_ROUTE = `${WORKSPACE_SLUG}/contacts-tab`;
export const CONTACTS_MANAGE_PERMISSIONS_ROUTE = `${CONTACTS_ROUTE}/manage-permissions`;

export const DEFAULT_HOME_PATH = `${BASE_SHOPS_PATH}/all`;
export const HOME = `${BASE_SHOPS_PATH}/:status`;
export const ORDER_HOME = `${BASE_SHOPS_PATH}/orders`;
export const ORDER_SETUP_MAIN = `${BASE_SHOPS_PATH}/orders/:number`;
export const ORDER_SETUP_CONTACTS = `${ORDER_SETUP_MAIN}/contacts/:category`;
export const ORDER_SETUP_BUDGET = `${BASE_SHOPS_PATH}/orders/:number/budget`;
export const ORDER_SETUP_RECIPIENT = `${BASE_SHOPS_PATH}/orders/:number/recipients`;
export const ORDER_SETUP_MESSAGE = `${BASE_SHOPS_PATH}/orders/:number/personalized-message`;
export const ORDER_SETUP_CHECKOUT = `${BASE_SHOPS_PATH}/orders/:number/checkout`;
export const ORDER_ADD_RECIPIENTS = `${BASE_SHOPS_PATH}/orders/:number/add-recipients`;
export const ORDER_ADD_RECIPIENT_PREFERENCE = `${BASE_SHOPS_PATH}/orders/[number]/add-recipient-preference`;
export const ORDER_CREATE_ROUTE = `${BASE_SHOPS_PATH}/orders/create/new`;

export const ORDER_APPROVE_RECIPIENTS = `${BASE_SHOPS_PATH}/orders/:number/approve-recipients`;
export const DUPLICATE_SHOP = `${BASE_SHOPS_PATH}/duplicate-shop/:number`;
export const SETTINGS_ORDER = "/settings";
export const VIEW_MESSAGES_SETTINGS_ORDER = `${SETTINGS_ORDER}/messages`;
export const SHOP_REDEEM = `${BASE_SHOPS_PATH}/redeem`;
export const REQUEST_DOMAIN = `${BASE_SHOPS_PATH}/:number/request-domain`;
export const FULL_ZAPIER_EXPERIENCE = `${BASE_SHOPS_PATH}/integrations/full-zapier-experience`;
export const TEMPLATES = `${BASE_SHOPS_PATH}/templates`;
export const TEMPLATES_ALL = `${TEMPLATES}/all`;
export const DEFAULT_TEMPLATES_PAGE_ROUTE = `${TEMPLATES}/${DEFAULT_CATERGORY_SLUG}`;
export const MOMENTS = "moments";
export const MOMENTS_ROUTE = `${BASE_SHOPS_PATH}/${MOMENTS}`;
export const MOMENTS_ALL = `${MOMENTS_ROUTE}/all`;
export const DEFAULT_MOMENTS_PAGE_ROUTE = `${MOMENTS_ROUTE}/${DEFAULT_CATERGORY_SLUG}`;

//My purchases
export const MY_ORDERS_PATH = `${BASE_SHOPS_PATH}/my-orders/${MY_PURCHASES}`;
export const SWAG_ORDERS_PATH = `${BASE_SHOPS_PATH}/my-orders/${MY_SWAG_ORDERS}`;
export const SENT_GIFTS_PATH = `${BASE_SHOPS_PATH}/my-orders/${MY_SENT_GIFTS}`;
export const RECIPIENT_PURCHASES_PATH = `${BASE_SHOPS_PATH}/my-orders/${RECIPIENT_PURCHASES}`;
export const RECEIVED_GIFTS_PATH = "/received-gifts";

//campaign
export const CAMPAIGN_DASHBOARD_ROUTE = "/automated-gifting";
export const CAMPAIGN_SETUP_PATH = "/automation-setup/:number";
export const CAMPAIGN_ORDER_SETUP_DETAILS = `${CAMPAIGN_SETUP_PATH}/details`;
export const CAMPAIGN_ORDER_SETUP_RECIPIENT = `${CAMPAIGN_SETUP_PATH}/recipients`;
export const CAMPAIGN_ORDER_SETUP_GIFT_TYPE = `${CAMPAIGN_SETUP_PATH}/gift-type`;
export const CAMPAIGN_ORDER_SETUP_MESSAGE = `${CAMPAIGN_SETUP_PATH}/message`;
export const CAMPAIGN_ORDER_SETUP_CHECKOUT = `${CAMPAIGN_SETUP_PATH}/checkout`;

export const CAMPAIGN_DASHBOARD_ROUTE_WITH_WORKSPACE = `${MY_WORKSPACE_BASE_PATH}/${CAMPAIGN_DASHBOARD_ROUTE}/[number]`;
export const CAMPAIGN_DETAIL_BASE_PATH = `${CAMPAIGN_DASHBOARD_ROUTE}/:number`;
export const CAMPAIGN_EDIT_PAYMENT_PATH = `${CAMPAIGN_DASHBOARD_ROUTE}/:number/edit/payment`;
export const CAMPAIGN_EDIT_RECIPIENTS_PATH = `${CAMPAIGN_DASHBOARD_ROUTE}/:number/edit/recipients`;
export const CAMPAIGN_SETTINGS_PATH = `${CAMPAIGN_DASHBOARD_ROUTE}/:number/settings`;
export const CREATE_CAMPAIGN_ROUTE = `${CAMPAIGN_DASHBOARD_ROUTE}/create`;

//p2p
export const PROGRAMS_DASHBOARD_ROUTE = "/recognition";
export const CREATE_PROGRAM_ROUTE = `${PROGRAMS_DASHBOARD_ROUTE}/programs/new`;
export const PROGRAM_SETUP_BASE_PATH = `${PROGRAMS_DASHBOARD_ROUTE}/programs/[number]`;
export const PROGRAM_SETUP_DETAILS = `${PROGRAM_SETUP_BASE_PATH}/details`;
export const PROGRAM_SETUP_USERS = `${PROGRAM_SETUP_BASE_PATH}/users`;
export const PROGRAM_SETUP_ASSIGN = `${PROGRAM_SETUP_BASE_PATH}/assign`;
export const PROGRAM_SETUP_CHECKOUT = `${PROGRAM_SETUP_BASE_PATH}/checkout`;
export const EDIT_PROGRAM_FLOW_BASE_PATH = `${PROGRAMS_DASHBOARD_ROUTE}/programs/[number]/edit`;
export const EDIT_PROGRAM_FLOW_USERS = `${EDIT_PROGRAM_FLOW_BASE_PATH}/users`;
export const EDIT_PROGRAM_FLOW_ASSIGN = `${EDIT_PROGRAM_FLOW_BASE_PATH}/assign`;
export const EDIT_PROGRAM_FLOW_PAY = `${EDIT_PROGRAM_FLOW_BASE_PATH}/review-pay-payment`;
export const EDIT_PROGRAM_FLOW_CHECKOUT = `${EDIT_PROGRAM_FLOW_BASE_PATH}/checkout`;
export const PAUSED_PROGRAM_PAYMENT_FLOW_BASE_PATH = `${PROGRAMS_DASHBOARD_ROUTE}/programs/[number]/pay`;
export const PAUSED_PROGRAM_PAYMENT_FLOW_PAY = `${PAUSED_PROGRAM_PAYMENT_FLOW_BASE_PATH}/review-pay-payment`;
export const PAUSED_PROGRAM_PAYMENT_FLOW_CHECKOUT = `${PAUSED_PROGRAM_PAYMENT_FLOW_BASE_PATH}/checkout`;

//company-space
export const COMPANY_SPACE_ROUTE = "/admin/[slug]";
export const COMPANY_SPACE_ADMIN_PANEL = `${COMPANY_SPACE_ROUTE}/dashboard`;
export const COMPANY_SPACE_BILLING = `${COMPANY_SPACE_ROUTE}/billing`;
export const COMPANY_SPACE_INTEGRATIONS = `${COMPANY_SPACE_ROUTE}/integrations`;
export const COMPANY_SETTINGS_ROUTE_WITHOUT_WORKSPACE = `${COMPANY_SPACE_ROUTE}/[setting]`;

export const COMPANY_SPACE_INTEGRATIONS_LINK = "/admin/integrations";

//company-space-with-workspace-slug
export const COMPANY_SETTINGS_ROUTE = "/[workspaceSlug]/admin/[slug]/[setting]";

//bundles
export const KIT_ORDER_SETUP_RECIPIENT = `${BASE_SHOPS_PATH}/kit-orders/:number/recipients`;
export const KIT_ORDER_SETUP_CUSTOMIZATION = `${BASE_SHOPS_PATH}/kit-orders/:number/customizations`;
export const KIT_ORDER_SETUP_CHECKOUT = `${BASE_SHOPS_PATH}/kit-orders/:number/checkout`;
export const SELECT_KIT_TYPE_ROUTE = `${KIT_DASHBOARD_ROUTE}/select-kit-type`;

export const KIT_DETAIL_BASE_PATH = `${BASE_SHOPS_PATH}/kits/:code`;

export const KIT_ITEMS_PAGE = `${KIT_DETAIL_BASE_PATH}/items`;
export const KIT_SEND_ORDER_PAGE = `${KIT_DETAIL_BASE_PATH}/send-orders`;
export const KIT_SEND_ORDER_PAGE_DYNAMIC_ROUTE = `${KIT_DETAIL_BASE_PATH}/kits/[code]/send-orders`;
export const KIT_SETTING_PAGE = `${KIT_DETAIL_BASE_PATH}/settings`;
export const KIT_REPORTS_PAGE = `${KIT_DETAIL_BASE_PATH}/reports`;

export const SHOP_PAGE = `${BASE_SHOPS_PATH}/:code`;

export const SHOP_THANKYOU_MESSAGES = `${SHOP_PAGE}/messages`;

export const PREVIEW_SHOP_CATALOG = `${SHOP_PAGE}/preview-catalog/:catalogNumber`;

export const SHOP_DETAILS_BASE_PATH = `${SHOP_PAGE}`;

export const SHOP_SEND_GIFT_PAGE = `${SHOP_DETAILS_BASE_PATH}/send-gifts`;
export const SHOP_SEND_GIFT_PAGE_DYNAMIC_ROUTE = `${BASE_SHOPS_PATH}/[code]/send-gifts`;
export const SHOP_LAYOUT_PAGE = `${SHOP_DETAILS_BASE_PATH}/layout`;
export const SHOP_ADD_USERS_ROUTE = `${SHOP_DETAILS_BASE_PATH}/add-user`;
export const SHOP_CATALOG_PAGE = `${SHOP_DETAILS_BASE_PATH}/catalog`;
export const SHOP_BRANDED_SWAG_PAGE = `${SHOP_DETAILS_BASE_PATH}/branded-swag`;
export const SHOP_SETTINGS_PAGE = `${SHOP_DETAILS_BASE_PATH}/settings`;
export const SHOP_REPORTS_PAGE = `${SHOP_DETAILS_BASE_PATH}/reports`;

//shop-settings
export const SHOP_SETTINGS_BASE_PATH = `${SHOP_DETAILS_BASE_PATH}/settings`;
export const SHOP_REQUEST_DOMAIN = `${SHOP_SETTINGS_BASE_PATH}/request-domain`;
export const SHOP_INTEGRATIONS = `${SHOP_SETTINGS_BASE_PATH}/integrations`;
export const SHOP_PRIVACY = `${SHOP_SETTINGS_BASE_PATH}/privacy`;
export const SHOP_SEO = `${SHOP_SETTINGS_BASE_PATH}/seo`;
export const SHOP_CUSTOMIZATIONS = `${SHOP_SETTINGS_BASE_PATH}/customizations`;
export const SHOP_USERS = `${SHOP_SETTINGS_BASE_PATH}/shop-users`;
export const SWAG_SETTINGS_PAGE = `${SHOP_SETTINGS_BASE_PATH}/swag`;

//shop-catalog
const SHOP_CATALOG_BASE_PATH = `${SHOP_DETAILS_BASE_PATH}/catalog`;
export const HIDE_UNHIDE_CATALOG = `${SHOP_CATALOG_BASE_PATH}/edit`;
export const SHOP_EDIT_MAIN_CATALOG = `${SHOP_DETAILS_BASE_PATH}/manage-catalog/main/:countryCode/:category`;
export const SHOP_EDIT_FEATURED_CATALOG = `${SHOP_DETAILS_BASE_PATH}/manage-catalog/featured/:countryCode/:category`;

//Universal-Points
export const UNIVERSAL_POINTS_HOME = `${BASE_SHOPS_PATH}/universal-points`;
export const UNIVERSAL_POINTS_MAIN_PATH = `${UNIVERSAL_POINTS_HOME}/:number`;
export const UNIVERSAL_POINTS_AMOUNT_PATH = `${UNIVERSAL_POINTS_MAIN_PATH}/amount`;
export const UNIVERSAL_POINTS_CHECKOUT_PATH = `${UNIVERSAL_POINTS_MAIN_PATH}/checkout`;

//priceless
export const PRICELESS_ORDER = `${BASE_SHOPS_PATH}/priceless-orders/:number`;
export const PRICELESS_ORDER_ITEM_SETUP = `${PRICELESS_ORDER}/item-setup`;
export const PRICELESS_ORDER_RECIPIENTS = `${PRICELESS_ORDER}/recipients`;
export const PRICELESS_ORDER_MESSAGE = `${PRICELESS_ORDER}/personalized-message`;

//points-history
const POINTS_HISTORY_PATH = `${BASE_SHOPS_PATH}/points-history`;
export const STADIUM_POINTS = `${POINTS_HISTORY_PATH}/stadium-points`;
export const SHOP_POINTS = `${POINTS_HISTORY_PATH}/shop-points`;

// recognition-programs
export const RECOGNITION_PROGRAMS_BASE = "/recognition/programs/list";
export const RECOGNITION_PROGRAMS_PARENT_TABS = `${RECOGNITION_PROGRAMS_BASE}/[tab]`;
export const RECOGNITION_PROGRAMS_STATUS_TABS = `${RECOGNITION_PROGRAMS_PARENT_TABS}/[status]`;
export const RECOGNITION_PROGRAMS_INVITED_TO_TAB = `${RECOGNITION_PROGRAMS_BASE}/invited-to`;
export const RECOGNITION_PROGRAMS_ALL_PROGRAMS = `${RECOGNITION_PROGRAMS_BASE}/all-programs`;

export const WAYS_TO_SPEND_PATH = `${BYSTADIUM_MARKETING_URL}/ways-to-spend`;

const CREATE_SHOP_BASE_ROUTE = `${BASE_SHOPS_PATH}/create`;
export const EDIT_TEMPLATE_ROUTE = `${CREATE_SHOP_BASE_ROUTE}/edit-template`;

export const TRACK_SHOP_ORDER = `${BASE_SHOPS_PATH}/orders/:number/track`;

//catalog-feedback
export const CATALOG_FEEDBACK_PATH = `${SHOP_PAGE}/catalog-feedback/:catalogNumber`;

//resources
export const RESOURCES_PATH = `${SHOPS_DASHBOARD_HOSTNAME}${BASE_SHOPS_PATH}/resources`;

// p2p feed
export const FEED_INDEX_ROUTE = "/recognition/programs/[number]/feed";
export const FEED_TAB_ROUTE = "/recognition/programs/[number]/feed/[tab]";
export const FEED_POST_NEW = "/recognition/programs/[number]/feed/post/new";
export const FEED_POST_ROUTE = "/recognition/programs/[number]/feed/post/[postId]";
export const FEED_USERS_LIST_ROUTE = "/recognition/programs/[number]/feed/users";

// p2p
export const RECOGNITION_PROGRAM_SETTINGS = "/recognition/programs/[number]/settings";
export const RECOGNITION_PROGRAM_SETTINGS_TAB = `${RECOGNITION_PROGRAM_SETTINGS}/[tab]`;
export const RECOGNITION_PROGRAM_SETTINGS_TAB_WITH_CHILD_TAB = `${RECOGNITION_PROGRAM_SETTINGS_TAB}/[childTab]`;

export const CUSTOMER_CASE_STUDIES_SLUG = "customer-case-studies";

export const getMyShopPageRoute = (status = DEFAULT_SHOP_TAB) => HOME.replace(":status", status);

export const getShopTrackOrderRoute = (number) => {
  return TRACK_SHOP_ORDER.replace(":number", number);
};

//assetLibrary
export const ASSET_LIBRARY_ROUTE = `${WORKSPACE_SLUG}/manage-assets`;
export const ASSET_LIBRARY_DETAIL_ROUTE = `${ASSET_LIBRARY_ROUTE}/:number`;

export const getAssetLibraryDetailRoute = ({ workspaceSlug, number }) => {
  return ASSET_LIBRARY_DETAIL_ROUTE.replace("[workspaceSlug]", workspaceSlug).replace(
    ":number",
    number,
  );
};

export const HOME_TABS = {
  myShops: {
    key: "myShops",
    title: "My Shops",
    route: getMyShopPageRoute(),
  },
  availableToShop: {
    key: "availableToShop",
    title: "Available To Shop",
    route: SHOP_REDEEM,
  },
};

export const CREATE_SHOP_MOBILE_TABS = {
  nameTab: {
    key: "nameTab",
    label: "Name",
  },
  logoTab: {
    key: "logoTab",
    label: "Logo",
  },
  bannerTab: {
    key: "bannerTab",
    label: "Top Banner",
  },
  currencyTab: {
    key: "currencyTab",
    label: "Currency",
  },
};

export const CREATE_SHOP_STEPS = {
  choose: {
    key: "choose",
    name: "Choose Template",
    route: TEMPLATES,
    stepNo: 0,
  },
  edit: {
    key: "edit",
    name: "Edit Appearance",
    route: EDIT_TEMPLATE_ROUTE,
    stepNo: 1,
  },
};

export const BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_PATH;

export const EXT_STADIUM_SHOP_URL = "https://www.bystadium.com/stores/stadium-gift-shop/S795725323";

export const getRequestDomainRoute = (number) => REQUEST_DOMAIN.replace(":number", number);
export const getDuplicateShopRoute = (number) => DUPLICATE_SHOP.replace(":number", number);

export const getOrderSettingsRoute = (number) => `${ORDER_HOME}/${number}${SETTINGS_ORDER}`;
export const getOrderViewMessagesRoute = (number) =>
  `${ORDER_HOME}/${number}${VIEW_MESSAGES_SETTINGS_ORDER}`;

export const getShopViewMessagesRoute = (code) => SHOP_THANKYOU_MESSAGES.replace(":code", code);

export const getDomainName = () => (!isDev() ? window.location.host : "");

export const getPreviewTemplateRoute = (storeUrl) => `${storeUrl}?preview=true`;

export const getShopDashboardRoute = (shopNumber, orderNumber) => {
  const orderPath = orderNumber ? `?order=${orderNumber}` : "";
  return `${SHOP_BRANDED_SWAG_PAGE.replace(":code", shopNumber)}${orderPath}`;
};

export const getKitSendOrdersRoute = ({ bundleNumber }) =>
  KIT_SEND_ORDER_PAGE.replace(":code", bundleNumber);

export const getShopSendGiftsRoute = (shopNumber, orderNumber) => {
  const orderPath = orderNumber ? `?order=${orderNumber}` : "";
  return `${SHOP_SEND_GIFT_PAGE.replace(":code", shopNumber)}${orderPath}`;
};

export const getShopCustomizationsSettingRoute = (code) =>
  SHOP_CUSTOMIZATIONS.replace(":code", code);
export const getShopAdminRoute = (code) => SHOP_USERS.replace(":code", code);
export const getGeneralShopSettingsRoute = (code) => SHOP_SETTINGS_BASE_PATH.replace(":code", code);
export const getShopSeoRoute = (code) => SHOP_SEO.replace(":code", code);
export const getShopIntegrationsRoute = (code) => SHOP_INTEGRATIONS.replace(":code", code);
export const getShopPrivacyRoute = (code) => SHOP_PRIVACY.replace(":code", code);
export const getShopLayoutRoute = (code) => SHOP_LAYOUT_PAGE.replace(":code", code);
export const getShopAddUserRoute = (code) => SHOP_ADD_USERS_ROUTE.replace(":code", code);
export const getBrandedMerchRoute = (code) => SHOP_BRANDED_SWAG_PAGE.replace(":code", code);
export const getSwagSettingsRoute = (code) => SWAG_SETTINGS_PAGE.replace(":code", code);
export const getPreviewCatalogRoute = (code, catalogNumber) =>
  PREVIEW_SHOP_CATALOG.replace(":code", code).replace(":catalogNumber", catalogNumber);
export const getHideUnhideRoute = (code) => HIDE_UNHIDE_CATALOG.replace(":code", code);
export const getShopEditCatalogRoute = ({
  code,
  countryCode,
  category = "all",
  isFeaturedMenuListing = false,
}) =>
  (!isFeaturedMenuListing ? SHOP_EDIT_MAIN_CATALOG : SHOP_EDIT_FEATURED_CATALOG)
    .replace(":code", code)
    .replace(":countryCode", countryCode)
    .replace(":category", category);

export const getUniversalPointsAmountRoute = (number) =>
  UNIVERSAL_POINTS_AMOUNT_PATH.replace(":number", number);
export const getUniversalPointsCheckoutRoute = (number) =>
  UNIVERSAL_POINTS_CHECKOUT_PATH.replace(":number", number);

export const getShopDetailPageRoute = (code) => `${SHOPS_DETAIL_MARKETING_PAGE}/${code}`;

export const getCatalogFeedbackRoute = (code, catalogNumber) =>
  CATALOG_FEEDBACK_PATH.replace(":code", code).replace(":catalogNumber", catalogNumber);

export const getStoreRouteWithoutCountryCode = ({ shopCode, shopNumber }) =>
  `${HOME_URL}/stores/${shopCode}/${shopNumber}`;

export const getStoreMenuRouteWithoutCountryCode = ({ shopCode, shopNumber }) =>
  `${getStoreRouteWithoutCountryCode({ shopCode, shopNumber })}/menu`;

export const getStoreCartRouteWithoutCountryCode = ({ shopCode, shopNumber }) =>
  `${getStoreRouteWithoutCountryCode({ shopCode, shopNumber })}/cart`;

export const getStoreAllProductPageRoute = ({ shopCode, shopNumber }) => {
  return `${getStoreRouteWithoutCountryCode({ shopCode, shopNumber })}/${ALL_PRODUCTS}`;
};

export const getStoreAllProductRouteWithCountry = ({
  shopCode,
  shopNumber,
  countryCode,
  lang = "en",
}) => {
  return `${HOME_URL}/${countryCode}/${lang}/stores/${shopCode}/${shopNumber}/${ALL_PRODUCTS}`;
};

export const getStoreCartRoute = ({ shopCode, shopNumber }) =>
  `${getStoreRouteWithoutCountryCode({ shopCode, shopNumber })}/cart`;

export const getStoreConfirmationPageRoute = ({ shopCode, shopNumber, orderNumber, query }) => {
  const params = new URLSearchParams(query);
  return `${getStoreRouteWithoutCountryCode({
    shopCode,
    shopNumber,
  })}/orders/${orderNumber}/confirmation?${params}`;
};

export const getKitDetailPageRoute = (bundleNumber) =>
  KIT_ITEMS_PAGE.replace(":code", bundleNumber);

export const getStoreMenuRoute = ({ countryCode = "", shopSlug = "", shopId }) =>
  `${HOME_URL}/${countryCode}/en/stores/${shopSlug}/${shopId}/menu`;

export const getOrderApproveRecipients = (ordernumber) =>
  ORDER_APPROVE_RECIPIENTS.replace(":number", ordernumber);

export const getOrderDetailPageRoute = (ordernumber, category = "") =>
  ORDER_SETUP_CONTACTS.replace(":number", ordernumber).replace(":category", category);

export const getAddRecipientsRoute = (orderNumber) => {
  return `${ORDER_ADD_RECIPIENTS.replace(":number", orderNumber)}`;
};

export const getAddRecipientPreferenceRoute = (number) =>
  generateUrlByQuery({
    query: {
      number,
    },
    pathname: ORDER_ADD_RECIPIENT_PREFERENCE,
  });

export const getFinishOrderRoute = (orderNumber) => {
  return `${ORDER_SETUP_BUDGET.replace(":number", orderNumber)}`;
};

/* This will automatically redirect to the `locker/collections/all` */
export const LOCKER_BASE_PATH = "/locker";

export const LOCKER_MY_DESIGNED_SWAG_URL = `${LOCKER_BASE_PATH}/saved`;
export const LOCKER_MY_DASHBOARD_SWAG_URL = `${LOCKER_BASE_PATH}`;
export const LOCKER_MY_INVENTORY_SWAG_URL = `${LOCKER_BASE_PATH}/inventory`;

export const LOCKER_MY_SWAG_COLLECTION = `${LOCKER_BASE_PATH}/collection/:collectionId`;

export const getKitOrderPageRoute = (orderNumber) =>
  KIT_ORDER_SETUP_RECIPIENT.replace(":number", orderNumber);

export const getStadiumLockerRestockUrl = (productSlug) =>
  STADIUM_LOCKER_RESTOCK_URL.replace(":productSlug", productSlug);

export const getCampaignDetailPageRoute = (number) =>
  CAMPAIGN_DETAIL_BASE_PATH.replace(":number", number);

export const getCampaignDetailUpcomingGiftsRoute = (number) =>
  generateUrlByQuery({
    pathname: getCampaignDetailPageRoute(number),
    query: { upcomingGiftsModal: "true" },
  });

export const getCampaignEditRecipientsPageRoute = (number) =>
  CAMPAIGN_EDIT_RECIPIENTS_PATH.replace(":number", number);

export const getCampaignSettingsPageRoute = (number) =>
  CAMPAIGN_SETTINGS_PATH.replace(":number", number);

export const getPricelessOrderPageRoute = (orderNumber) =>
  PRICELESS_ORDER_ITEM_SETUP.replace(":number", orderNumber);

export const LOCKER_DASHBOARD_INVENTORY_ROUTE = `${LOCKER_DASHBOARD_URL}/inventory`;

export const LIVE_SHOPS = "/shops/live";

export const TEMPLATES_DYNAMIC_ROUTE = "/shops/templates/[[...templateSlug]]";

export const getLockerDashboardRoute = ({ viewType = "collections", tab = "all" } = {}) =>
  generateUrlByQuery({
    pathname: LOCKER_DASHBOARD_TAB_URL,
    query: { viewType, tab },
  });

// Workspace Creation
export const WORKSPACE_CREATION_ROUTE = "/create-workspace/[slug]";
export const WORKSPACE_CREATION_SELECT_TEAM_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/select-team`;
export const WORKSPACE_CREATION_NAME_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/name`;
export const WORKSPACE_CREATION_SIZE_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/size`;
export const WORKSPACE_CREATION_ADD_ADMINS_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/add-admins`;
export const WORKSPACE_CREATION_OFFERINGS_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/offerings`;
export const WORKSPACE_CREATION_CHOOSE_PACKAGE_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/choose-package`;
export const WORKSPACE_CREATION_FREE_TRIAL_STEP_ROUTE = `${WORKSPACE_CREATION_ROUTE}/free-trial`;

//Maintenance
export const MAINTENANCE_ROUTE = "/maintenance";

export const getPointsHistoryRoute = ({ isSummaryRoute, tab }) => {
  if (isSummaryRoute) {
    return `${users.pointsSummary}/${tab}`;
  }
  return `${users.points}/${tab}`;
};

export const PRODUCT_CUSTOMIZE_ROUTE = "/shops/product/[slug]";
export const WORKSPACE_PRODUCT_CUSTOMIZE_ROUTE = `/[workspaceSlug]/${PRODUCT_CUSTOMIZE_ROUTE}`;

export const ALLOW_SSR_PATHS = ["/*/widget"];

export const getCompanySpaceAdminPanelRoute = (slug, queryParams = {}) => {
  const baseRoute = COMPANY_SPACE_ADMIN_PANEL.replace("[slug]", slug);
  if (Object.keys(queryParams).length === 0) {
    return baseRoute;
  }
  const queryString = new URLSearchParams(queryParams).toString();
  return `${baseRoute}?${queryString}`;
};
